__turbopack_context__.v({
  "emptyError": "StripeFields-module__Y8n3xW__emptyError",
  "label": "StripeFields-module__Y8n3xW__label",
  "stripeField": "StripeFields-module__Y8n3xW__stripeField",
  "stripeFieldError": "StripeFields-module__Y8n3xW__stripeFieldError",
  "stripeNotLoadedMessage": "StripeFields-module__Y8n3xW__stripeNotLoadedMessage",
});
